/*jshint esversion: 6 */

export default (function(selector) {
    if (typeof Vimeo === "undefined") {
        console.warn("Warning: The Vimeo SDK is not loaded on this page.");
        return;
    }

    const iframe = document.querySelector('iframe');
    if (!iframe) {
        console.warn("Warning: No iframe element found.");
        return;
    }

    const player = new Vimeo.Player(iframe);
    const elems = document.querySelectorAll(selector);

    if (elems.length === 0) {
        console.warn(`Warning: No elements found matching selector "${selector}"`);
        return;
    }

    const clearVideoTriggers = function(targetSelector) {
        const activeElems = document.querySelectorAll(targetSelector);
        activeElems.forEach(elem => elem.classList.remove("active"));
    };

    elems.forEach((elem, index) => {
        const advanceAttr = elem.getAttribute("advance");
        const advanceTime = parseInt(advanceAttr, 10);

        if (Number.isInteger(advanceTime)) {

            elem.addEventListener('click', function() {
                console.log(`Button clicked! Seeking to ${advanceTime}s...`);

                clearVideoTriggers(selector);
                this.classList.add("active");

                // Scroll the iframe into view smoothly
                iframe.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

                // Fire commands directly without awaiting hanging promises
                player.setCurrentTime(advanceTime);
                player.setMuted(false);

                player.play().catch(function(err) {
                    console.error("Playback error:", err);
                });
            });
        } else {
            elem.addEventListener('click', function() {
                console.error(`Error: Element attribute "advance" ("${advanceAttr}") is not a valid integer.`);
            });
        }
    });
});